const buttons = {
  borderRadius: '0',
  fontSize: '1rem',
  primary: {
    color: '#ffffff',
    colorHover: '#ffffff',
    background: '#007A68',
    backgroundHover: '#1E1E1E',
    border: 'none',
    padding: '0.4375rem 0.625rem'
  },
  secondary: {
    color: '#1E1E1E',
    colorHover: '#007A68',
    background: '#ffffff',
    backgroundHover: '#E1EFEC',
    border: '2px solid #1E1E1E',
    padding: '0.3125rem 0.5rem'
  },
  primaryAlt: {
    color: '#ffffff',
    colorHover: '#ffffff',
    background: '#1E1E1E',
    backgroundHover: '#007A68',
    border: 'none',
    padding: '0.4375rem 0.625rem'
  },
  secondaryAlt: {
    color: '#1E1E1E',
    colorHover: '#007A68',
    background: '#ffffff',
    backgroundHover: '#E1EFEC',
    border: 'none',
    padding: '0.4375rem 0.625rem'
  },
  disabled: {
    color: '#595959',
    background: '#E6E6E6',
    border: 'none',
    padding: '0.4375rem 0.625rem'
  }
};

export { buttons };
